import React from "react";
import "./Header.css";
import logo from "./assets/Zwirbellogo_Gelb.png";

const Header = () => {
  return (
    <header className="hero">
      <div className="hero-overlay">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="hero-content">
        <h1 className="hero-title">Zwirbelglace</h1>
        <h2 className="hero-subtitle">
          New Zealand style Real Fruit Ice Cream
        </h2>
      </div>
    </header>
  );
};

export default Header;
